import React, { useContext, useEffect } from "react"
import { HashRouter as Router, Switch, Route, Redirect } from "react-router-dom"
import {
  ConfigurationEmailConfirmationView,
  PageInConstructionView,
  VerifyContractView,
  ChatbotConfigurationConversation
} from "../components/views"
import {
  ProfileAction,
  ConfigurationDomainsAction,
  ChangePasswordEmailAction,
  BusinessAdministrationAction,
  CustomizationAction,
  ClientsDashboardProfileAction,
  ClientsDashboardTicketAction,
  ClientProfileAction,
  ReportsAndStatisticsAction,
  UserAdministrationNewAction,
  ChatbotConfigurationGeneralAction,
  ChatbotEditConversationFlowAction,
  BranchOfficeAction,
  BranchOfficeDetailsAction,
  UploadMultipleAction,
  UsageAction,
  ChatsAction,
  HistoryAction,
  AssistantAction,
  BotAdministrationAction,
  GroupAdministrationAction
} from '../components/actions'
import { ProtectedRoute } from "../components/hoc"
import { Context } from "../Context"

/**
 *
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const MyRoute = (props) => {
  const { setAllowedActions } = useContext(Context)
  let modules = localStorage.getItem("modules")

  useEffect(() => {
    const currentModule = modules.find(module => module.path === props.path)
    console.log('currentModule', currentModule)
    if (!currentModule) return

    const actions = currentModule.moduleRoles && currentModule.moduleRoles.length ? currentModule.moduleRoles[0].actions : null
    setAllowedActions(actions)
  }, [modules, props.path, setAllowedActions])

  modules = JSON.parse(modules)
  if (!modules || modules.length <= 0) return false

  let validPath = false
  for (let i = 0; i < modules.length; i++) {
    if (modules[i].path === props.path) {
      validPath = true
      break
    }
  }
  return validPath === true ? <Route {...props} /> : <Redirect to="/" />
}


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const Routes = (props) => {

  const { onInvitedRedirectRegister } = props

  const isAdmin = (() => {
    try {
      const rawUser = localStorage.getItem("user")
      const user = rawUser ? JSON.parse(rawUser) : null
      const userRoles = user?.userMetaData?.userRoles ?? []
      return !!userRoles.find(ur => ur.role.key === process.env.REACT_APP_ROLE_GENERAL_ADMIN)
    } catch { return false }
  })()

  return (
    <React.Fragment>
      <Router>
        <Switch>
          <MyRoute
            exact={true}
            path="/change-password-user"
            component={ChangePasswordEmailAction}
          />
          {props.defaultRoute && <Redirect exact from="/" to={props.defaultRoute} />}
          <MyRoute
            exact={true}
            path="/clients-dashboard/:userId"
            component={ClientsDashboardProfileAction}
          />
          <MyRoute
            exact={true}
            path="/client-profile"
            component={ClientProfileAction}
          />
          <MyRoute
            exact={true}
            path="/clients-dashboard/ticket/:ticketId"
            component={ClientsDashboardTicketAction}
          />
          <MyRoute
            exact={true}
            path="/profile"
            render={() => (
              <ProfileAction
                {...props}
                onInvitedRedirectRegister={onInvitedRedirectRegister}
                reloadProfileImage={props.reloadProfileImage}
              />
            )}
          />
          <MyRoute
            exact={true}
            path="/confirmation"
            component={ConfigurationEmailConfirmationView}
          />
          <MyRoute
            exact={true}
            path="/page-in-construction"
            component={PageInConstructionView}
          />
          <MyRoute
            exact={true}
            path="/waiting-authorization"
            component={VerifyContractView}
          />
          <MyRoute
            exact={true}
            path="/domain-administration"
            component={ConfigurationDomainsAction}
          />
          <MyRoute
            exact={true}
            path="/group-administration"
            component={GroupAdministrationAction}
          />
          <ProtectedRoute
            exact={true}
            path="/user-administration"
            requireAdmin={true}
          >
            <UserAdministrationNewAction />
          </ProtectedRoute>
          <ProtectedRoute
            exact={true}
            path='/bot-administration'
            requireAdmin={true}
          >
            <BotAdministrationAction />
          </ProtectedRoute>
          <MyRoute
            exact={true}
            path="/business-administration"
            component={BusinessAdministrationAction}
          />
          <MyRoute
            exact={true}
            path="/customization"
            render={() => (
              <CustomizationAction
                reloadLogo={props.reloadLogo}
              />
            )}
          />
          <MyRoute
            exact={true}
            path="/reports"
            component={ReportsAndStatisticsAction}
          />
          <MyRoute
            exact={true}
            path="/assistant-configuration"
            component={ChatbotConfigurationGeneralAction}
          />
          <MyRoute
            exact={true}
            path="/assistant-conversation"
            component={ChatbotConfigurationConversation}
          />
          <MyRoute
            exact={true}
            path="/assistant-configuration/conversation/:conversationId"
            component={ChatbotEditConversationFlowAction}
          />
          <MyRoute
            exact={true}
            path="/branch-offices-administration"
            component={BranchOfficeAction}
          />
          <MyRoute
            exact={true}
            path="/branch-office-details"
            component={BranchOfficeDetailsAction}
          />
          <MyRoute
            exact={true}
            path="/create-branch-offices"
            component={UploadMultipleAction}
          />
          <MyRoute
            exact={true}
            path="/usage"
            component={UsageAction}
          />
          <MyRoute
            exact={true}
            path='/chats'
            component={ChatsAction}
          />
          <MyRoute
            exact={true}
            path='/history'
            component={HistoryAction}
          />
          <MyRoute
            exact={true}
            path='/assistant'
            component={AssistantAction}
          />
          <Redirect to="/" />
        </Switch>
      </Router>
    </React.Fragment>
  )
}

export { Routes as default }
